const KEY = "sefano.postLoginRedirect";

/** Remember an in-app path to return to once the user has signed in (any login flow). */
export function setPostLoginRedirect(path: string) {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage unavailable (private mode): the user just lands on the dashboard.
  }
}

/** The remembered path, cleared on read. Only same-app paths are accepted. */
export function consumePostLoginRedirect(): string | null {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && path.startsWith("/") && !path.startsWith("//") ? path : null;
  } catch {
    return null;
  }
}
